import colors from '../../theme/foundations/colors'
import {fonts} from '../../theme/foundations/fonts'
import sizes from '../../theme/foundations/sizes'
import {pxToRem} from '../../utills/pxToRem'

export const placeOrderButtonStyle = {
    marginTop: pxToRem(45),
    backgroundColor: 'cav_red',
    textAlign: 'center',
    fontFamily: fonts.primary,
    fontSize: pxToRem(14),
    fontWeight: '700',
    lineHeight: pxToRem(13.5),
    letterSpacing: pxToRem(1.5),
    textTransform: 'uppercase',
    width: '100%',
    height: pxToRem(40),
    padding: `${pxToRem(12)} ${pxToRem(20)}`,
    borderRadius: '0px',
    '&:hover': {
        border: `${pxToRem(1)} solid ${colors.cav_red}`,
        borderRadius: '0px',
        textDecoration: 'none',
        backgroundColor: 'white',
        color: 'cav_red'
    },
    '&:disabled': {
        backgroundColor: 'cav_red',
        '&:hover': {
            color: 'white',
            backgroundColor: 'cav_red'
        }
    },
    [`@media (max-width: ${sizes.container.md})`]: {
        marginTop: pxToRem(20),
        fontSize: pxToRem(12)
    }
}

export const placeOrderButtonBelowPaymentStyle = {
    ...placeOrderButtonStyle,
    marginTop: pxToRem(25)
}
export const amountDueLabel = {
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(16)],
    fontWeight: '500',
    lineHeight: 'normal',
    letterSpacing: [pxToRem(1)],
    marginBottom: `0 !important`
}
export const termsPrivacyInfo = {
    color: 'cav_pdp_dark_gray',
    textAlign: 'center',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(13)],
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: [pxToRem(1)],
    marginTop: `${pxToRem(15)} !important`,
    marginBottom: `0 !important`
}
export const termsPrivacyInfoLink = {
    color: 'cav_calltoaction_darkred',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(13)],
    fontWeight: '500',
    lineHeight: 'normal',
    letterSpacing: [pxToRem(1)],
    textDecoration: 'none',
    '&:hover': {
        textDecoration: 'underline'
    }
}

export const dispalyShipingAddress = {
    '.radio-styles': {
        '.chakra-radio__control': {
            marginTop: pxToRem(4),
            marginRight: pxToRem(8),
            borderColor: 'black',
            background: 'none',
            backgroundColor: 'none',
            borderWidth: pxToRem(1)
        },
        '.chakra-radio__control[data-checked]': {
            background: 'none',
            backgroundColor: 'none',
            border: `${pxToRem(1)} solid`,
            borderColor: 'black'
        },
        '.chakra-radio__control[data-checked]::before': {
            backgroundColor: 'black',
            margin: `${pxToRem(3)} auto`,
            height: pxToRem(8),
            width: pxToRem(8)
        }
    }
}
export const pageHeader = {
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(22), pxToRem(22), pxToRem(30), pxToRem(30)],
    fontWeight: '600',
    lineHeight: 'normal',
    letterSpacing: [pxToRem(3), pxToRem(3), pxToRem(4), pxToRem(4)],
    marginBottom: 0,
    marginLeft: [pxToRem(11), pxToRem(11), 0, 0],
    marginRight: [pxToRem(11), pxToRem(11), 0, 0]
}
export const headingStyle = {
    color: 'black',
    textAlign: 'center',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(22), pxToRem(22), pxToRem(30), pxToRem(30)],
    fontWeight: '600',
    lineHeight: 'normal',
    letterSpacing: [pxToRem(3), pxToRem(3), pxToRem(4), pxToRem(4)],
    textTransform: 'uppercase',
    marginBottom: '0px'
}
export const orderTextStyle = {
    marginTop: [pxToRem(25), pxToRem(25), pxToRem(30), pxToRem(30)],
    marginBottom: '0px',
    color: 'black',
    textAlign: 'center',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(14), pxToRem(14), pxToRem(16), pxToRem(16)],
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1)
}
export const orderIdStyle = {
    marginTop: [pxToRem(25), pxToRem(25), pxToRem(30), pxToRem(30)],
    marginBottom: '0px',
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(14), pxToRem(14), pxToRem(16), pxToRem(16)],
    fontWeight: '500',
    lineHeight: 'normal',
    letterSpacing: [pxToRem(1), pxToRem(1), pxToRem(1.28), pxToRem(1.28)]
}
export const textStyle = {
    marginTop: [
        `${pxToRem(20)} !important`,
        `${pxToRem(20)} !important`,
        `${pxToRem(30)} !important`,
        `${pxToRem(30)} !important`
    ],
    color: 'black',
    textAlign: 'center',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(14), pxToRem(14), pxToRem(16), pxToRem(16)],
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    b: {
        color: 'black',
        fontFamily: fonts.primary,
        fontSize: [pxToRem(14), pxToRem(14), pxToRem(16), pxToRem(16)],
        fontWeight: '500',
        lineHeight: 'normal',
        letterSpacing: pxToRem(1)
    }
}
export const buttonStyle = {
    marginTop: [
        `${pxToRem(20)} !important`,
        `${pxToRem(20)} !important`,
        `${pxToRem(25)} !important`,
        `${pxToRem(25)} !important`
    ],
    marginLeft: 'auto !important',
    marginRight: 'auto !important',
    width: pxToRem(295),
    height: pxToRem(40),
    padding: `${pxToRem(12)} ${pxToRem(20)}`,
    borderRadius: '0px',
    alignItems: 'center',
    background: 'cav_red',
    color: 'white',
    textAlign: 'center',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(12), pxToRem(12), pxToRem(14), pxToRem(14)],
    fontWeight: '700',
    lineHeight: pxToRem(13.5),
    letterSpacing: pxToRem(1.5),
    textTransform: 'uppercase',
    '&:hover': {
        background: 'white',
        color: 'cav_red',
        textDecoration: 'none'
    }
}
export const shippingHeadingStyle = {
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: pxToRem(22),
    fontWeight: '600',
    lineHeight: 'normal',
    letterSpacing: pxToRem(3),
    textTransform: 'uppercase',
    marginBottom: '0px'
}
export const shippingAddressHeadingStyle = {
    marginTop: pxToRem(30),
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '500',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    textTransform: 'capitalize',
    marginBottom: '0px'
}
export const shippingMethodHeadingStyle = {
    marginTop: pxToRem(30),
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '500',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    textTransform: 'capitalize',
    marginBottom: '0px'
}
export const addressDetailStyle = {
    marginTop: `${pxToRem(10)} !important`,
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    p: {
        marginBottom: '0px'
    }
}
export const methodNameStyle = {
    marginTop: `${pxToRem(10)} !important`,
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    marginBottom: '0px'
}
export const descriptionStyle = {
    color: 'cav_light_input_gray',
    fontFamily: fonts.primary,
    fontSize: pxToRem(13),
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    marginBottom: '0px'
}
export const itemsStyle = {
    marginTop: pxToRem(30),
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1)
}
export const createAccountButtonStyle = {
    padding: `${pxToRem(12)} ${pxToRem(20)}`,
    borderRadius: '0px',
    alignItems: 'center',
    background: 'cav_red !important',
    color: 'white',
    textAlign: 'center',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(12), pxToRem(12), pxToRem(14), pxToRem(14)],
    fontWeight: '700',
    lineHeight: pxToRem(13.5),
    letterSpacing: pxToRem(1.5),
    textTransform: 'uppercase',
    '&:hover': {
        background: 'white !important',
        color: 'cav_red',
        textDecoration: 'none'
    }
}
export const logoStyle = {
    width: [pxToRem(182.796), pxToRem(182.796), pxToRem(242.204), pxToRem(242.204)],
    height: [pxToRem(40), pxToRem(40), pxToRem(53), pxToRem(53)],
    marginBottom: [pxToRem(15), pxToRem(15), pxToRem(20), pxToRem(20)]
}
export const eyeIconStyle = {
    marginTop: pxToRem(92),
    color: 'gray.500',
    '&:hover': {
        background: 'none'
    }
}
export const paymentMethodIdStyle = {
    marginTop: pxToRem(10),
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '500',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    marginBottom: '0px'
}
export const amountStyle = {
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '500',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    marginBottom: '0px'
}
